import './actionsPopup.less'
import { Popup, StrictPopupProps } from 'semantic-ui-react'
import React, { useState } from 'react'
import { DotsThreeOutline, DotsThreeOutlineVertical } from 'phosphor-react'

interface IProps {
  trigger?: string | React.ReactElement
  triggerSize?: number
  triggerPosition?: 'vertical' | 'horizontal'
  content: string | React.ReactElement
  disabled?: boolean
  position?: StrictPopupProps['position']
  className?: string
  testContext?: string
}

const ActionsPopup = (props: IProps) => {
  const {
    trigger,
    position = 'bottom center',
    className = '',
    triggerSize = 26,
    triggerPosition = 'horizontal',
    content,
    disabled,
    testContext = ''
  } = props

  const [isOpened, setOpened] = useState(false)
  const handlePopupOpen = () => setOpened(true)
  const handlePopupClose = () => setOpened(false)

  return (
    <Popup
      data-test-id="actions-popup"
      disabled={disabled}
      className={`actions-popup ${className}`}
      position={position}
      open={isOpened}
      onOpen={handlePopupOpen}
      onClose={handlePopupClose}
      closeOnDocumentClick
      on="click"
      {...(testContext ? { 'data-test-context': testContext } : {})}
      trigger={
        <div className="actions-popup-trigger">
          {trigger}
          {!trigger && (
            <button
              className="btn icon-box actions-trigger"
              disabled={disabled}
              data-test-id="actions-popup-trigger"
            >
              {triggerPosition === 'horizontal' ? (
                <DotsThreeOutline
                  size={triggerSize}
                  weight="fill"
                  color="var(--color-ropa-button)"
                />
              ) : (
                <DotsThreeOutlineVertical
                  size={triggerSize}
                  weight="fill"
                  color="var(--color-ropa-button)"
                />
              )}
            </button>
          )}
        </div>
      }
      content={
        <div className="buttons" onClick={handlePopupClose}>
          {content}
        </div>
      }
    />
  )
}

export default ActionsPopup
